<template>
    <div>
        <div v-if="productImageBeingViewed" class="muven-product-big-image-visualization">
            <div class="muven-product-big-image-backdrop">

            </div>

            <div class="muven-product-big-image-container">
                <div class="muven-product-big-image">
                    <img :src="productImageUrl" alt="Imagem" />

                    <fa icon="times" 
                        class="muven-product-big-image-close-icon" 
                        @click="closeProductImageVisualization()"/>
                </div>
            </div>
        </div>

        <div class="muven-column-layout">
            <div class="muven-column-left">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>{{product.name}}</p>
                        <p class="text-muted">SKU: {{product.skuCode | infoOrPlaceholder}}</p>
                        <p class="text-muted">Código retaguarda: {{product.codeSource | infoOrPlaceholder}}</p>
                    </div>

                    <div class="row main-product-info-container">
                        <div class="col-12 mb-3">
                            <label>Descrição principal</label>
                            <p v-show="product.hasDescription()" v-html="product.getDescriptionWithLineBreaks()"></p>
                            <p v-show="!product.hasDescription()">-</p>
                        </div>

                        <div class="col-12 mb-3">
                            <label>Descrição curta</label>
                            <p v-show="product.hasDescriptionShort()" v-html="product.getDescriptionShortWithLineBreaks()"></p>
                            <p v-show="!product.hasDescriptionShort()">-</p>
                        </div>

                        <div class="col-12 mb-3">
                            <label>Descrição longa</label>
                            <p v-show="product.hasDescriptionLong()" v-html="product.getDescriptionLongWithLineBreaks()"></p>
                            <p v-show="!product.hasDescriptionLong()">-</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3" v-show="!product.hasMoreThanOneStore()">
                    <div class="muven-card-title">
                        <p>Dados complementares</p>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col-12 col-md-4 mb-3">
                                <label>NCM</label>
                                <p>{{product.ncmCode | infoOrPlaceholder}}</p>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <label>EAN</label>
                                <p>{{product.eanCode | infoOrPlaceholder}}</p>
                            </div>

                            <div class="col-12 col-md-4 mb-3">
                                <label>Tipo de produto</label>
                                <p>
                                    <span v-if="product.isVirtual">Virtual</span>
                                    <span v-if="!product.isVirtual">Físico</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Categorias</p>
                    </div>

                    <div class="">
                        <div>
                            <label class="pb-0 mb-0">Nome</label>
                        </div>

                        <div class="mt-3" v-for="(productCategoryChannel, index) in product.getCategories()" :key="index">
                            <p class="">{{productCategoryChannel.category.name | infoOrPlaceholder}}</p>
                        </div>

                        <div v-if="!product.hasCategories()">
                            <p>-</p>
                        </div>                            
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Marca</p>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label>Nome</label>
                            <p>{{product.getBrand().name | infoOrPlaceholder}}</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>SEO</p>
                    </div>

                    <div class="row">
                        <div class="col-12 mb-3">
                            <label>Título</label>
                            <p>{{product.seoTitle | infoOrPlaceholder}}</p>
                        </div>

                        <div class="col-12 mb-3">
                            <label>Descrição</label>
                            <p>{{product.seoDescription | infoOrPlaceholder}}</p>
                        </div>

                        <div class="col-12">
                            <label>Palavras chave</label>
                            <p>{{product.seoKeywords | infoOrPlaceholder}}</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Vídeo</p>
                    </div>

                    <div>
                        <label>URL do vídeo</label>
                        <p>{{product.videoUrl | infoOrPlaceholder}}</p>
                    </div>
                </div>

                <div class="muven-card mb-3 store-info-card" v-show="product.hasMoreThanOneStore()">
                    <div class="muven-card-title">
                        <p>Informações por loja</p>
                    </div>

                    <div class="muven-card-content" v-if="product.hasStores()">
                        <div class="row">
                            <div class="col-12 col-md-6 mb-3">
                                <label>Estoque somado</label>
                                <p>{{product.totalStockQtyInStores()}}</p>
                            </div>

                            <div class="col-12 col-md-6 mb-3">
                                <label>Fator de conversão</label>
                                <p>{{product.stockConversionRatio | infoOrPlaceholder}}</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 mb-3">
                                <label>Informações por loja</label>
                                <multiselect
                                    v-model="chosenStore"
                                    :options="productStoreList"
                                    :multiple="false"
                                    :show-labels="false"
                                    :allow-empty="false"
                                    label="name"
                                    track-by="id"
                                    @select="chooseStoreFromList"
                                    placeholder="" />
                                <small v-show="!!chosenProductStore.updatedAt" class="text-muted">Última atualização em {{chosenProductStore.updatedAt | dateTimeFilter | infoOrPlaceholder}}</small>
                            </div>
                        </div>

                        <div class="">
                            <div class="row">
                                <div class="col-12 col-md-4 mb-3">
                                    <label>Preço de custo</label>
                                    <p>{{chosenProductStore.costPrice | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 mb-3">
                                    <label>Preço de listagem</label>
                                    <p>{{chosenProductStore.listPrice | currency}}</p>
                                </div>

                                <div class="col-12 col-md-4 mb-3">
                                    <label>Preço de venda</label>
                                    <p>{{chosenProductStore.sellPrice | currency}}</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <label>Estoque</label>
                                    <p>{{chosenProductStore.stockQty | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 col-md-4">
                                    <label>Estoque reservado</label>
                                    <p>
                                        {{chosenProductStore.reservedStockQty | infoOrPlaceholder}}

                                        <a :href="urlToReservedStockOrder" 
                                            target="_blank"    
                                            v-show="!!chosenProductStore.reservedStockQty"
                                            class="text-muted">
                                            <fa icon="external-link-alt" class="ml-3" />
                                        </a>
                                    </p>
                                </div>

                                <div class="col-12 col-md-4">
                                    <label>Estoque disponível</label>
                                    <p>{{chosenProductStore.totalAvailableStockQty()}}</p>
                                </div>
                            </div>

                            <div class="mt-3" v-show="chosenProductStoreHasChannels">
                                <table class="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>Canal</th>
                                            <th>Preço (listagem / venda)</th>
                                            <th>Estoque disponível</th>
                                            <th>Id canal</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(channel, index) in chosenProductStore.channels" :key="index">
                                            <td>{{channel.channel.name | infoOrPlaceholder}}</td>
                                            <!-- <td>{{channel.calculatedListPrice | currency}} / {{channel.calculatedSellPrice | currency}}</td> -->
                                            <td>{{channel.listPrice | currency}} / {{channel.sellPrice | currency}}</td>
                                            <td>{{chosenProductStore.totalAvailableStockQty() | infoOrPlaceholder}}</td>
                                            <td>{{channel.idExternalChannel | infoOrPlaceholder}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="muven-column-right">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Status</p>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <p>
                                <span v-if="product.isActive">Ativo</span>
                                <span v-if="!product.isActive">Inativo</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Pedidos</p>
                    </div>

                    <div>
                        <div>
                            <p>Listar pedidos com este produto
                                <a :href="urlToOrder" 
                                    target="_blank"    
                                    class="text-muted">
                                    <fa icon="external-link-alt" class="ml-2" />
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Integração retaguarda</p>
                    </div>

                    <div>
                        <div class="mb-3">
                            <label>Id na retaguarda</label>
                            <p>{{product.idSource | infoOrPlaceholder}}</p>
                        </div>                          

                        <div class="mb-3">
                            <label>Código na retaguarda</label>
                            <p>{{product.codeSource | infoOrPlaceholder}}</p>
                        </div>                

                        <div class="mb-3">
                            <label>Importação da retaguarda</label>
                            <p>{{product.getAllowImportDescription() | infoOrPlaceholder}}</p>
                        </div>          

                        <div v-show="!product.hasMoreThanOneStore()">
                            <div class="mb-3">
                                <label>Preços (custo / listagem / venda)</label>
                                <p>{{product.costPrice | currency}} / {{product.listPrice | currency}} / {{product.sellPrice | currency}}</p>
                            </div>                                            

                            <div class="mb-3">
                                <label>Estoque (total / separado / disponível)</label>
                                <p>
                                    <span>{{product.totalStockQtyInStores() | infoOrPlaceholder}}</span>
                                    <span> / </span> 
                                    <span>{{product.totalReservedStockQtyInStores() | infoOrPlaceholder}}

                                        <a :href="urlToReservedStockOrder" 
                                            target="_blank"
                                            v-show="!!product.totalReservedStockQtyInStores()"
                                            class="text-muted">
                                            <fa icon="external-link-alt" class="ml-3" />
                                        </a>
                                    </span>
                                    <span> / </span>
                                    <span>{{product.totalAvailableStockQtyInStores() | infoOrPlaceholder}}</span>
                                </p>
                            </div>

                            <div class="mb-3">
                                <label>Fator de conversão de estoque</label>
                                <p>{{product.stockConversionRatio | infoOrPlaceholder}}</p>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label>Dias para entrega</label>
                            <p>{{product.additionalDeliveryDays | infoOrPlaceholder}}</p>
                        </div>                          

                        <div>
                            <label>Atualização cadastral</label>
                            <p>{{product.updatedAt | dateTimeFilter | infoOrPlaceholder}}</p>
                        </div>

                        <div class="mt-3" v-if="product.hasStores() && !product.hasMoreThanOneStore()">
                            <label>Atualização por loja</label>
                            <p>{{product.stores[0].updatedAt | dateTimeFilter | infoOrPlaceholder}}</p>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3" v-for="(storeChannel, index) in product.getUniqueStoreChannels()" :key="index"
                    v-show="product.hasStores() && !product.hasMoreThanOneStore()">
                    <div class="muven-card-title">
                        <p>Integração {{storeChannel.channel.name}}</p>
                    </div>

                    <div>
                        <div class="row">
                            <div class="col-12 mb-3">
                                <label>Id no canal</label>
                                <p>{{storeChannel.idExternalChannel | infoOrPlaceholder}}</p>
                            </div>

                            <div class="col-12 mb-3">
                                <label>Preços (listagem / venda)</label>
                                <!-- <p>{{storeChannel.calculatedListPrice | currency}}</p> -->
                                <p>{{storeChannel.listPrice | currency}} / {{storeChannel.sellPrice | currency}}</p>
                            </div>

                            <div class="col-12 mb-3">
                                <label>Estoque</label>
                                <p>{{storeChannel.calculatedStockQty | infoOrPlaceholder}}</p>
                            </div>

                            <div class="col-12">
                                <label>Status</label>
                                <p>
                                    <span v-show="storeChannel.isActive">Ativo</span>
                                    <span v-show="!storeChannel.isActive">Inativo</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="muven-card mb-3" v-if="!product.isVirtual">
                    <div class="muven-card-title">
                        <p>Cubagem</p>
                    </div>

                    <div class="row mb-3">
                        <div class="col-12 col-md-6">
                            <label>Peso</label>
                            <p>{{product.weight | infoOrPlaceholder}} kg</p>
                        </div>
                        <div class="col-12 col-md-6">
                            <label>Altura</label>
                            <p>{{product.height | infoOrPlaceholder}} cm</p>
                        </div>
                    </div>                        

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <label>Largura</label>
                            <p>{{product.width | infoOrPlaceholder}} cm</p>
                        </div>
                        <div class="col-12 col-md-6">
                            <label>Profundidade</label>
                            <p>{{product.depth | infoOrPlaceholder}} cm</p>
                        </div>

                    </div>
                </div>
            </div>

            <div class="muven-column-full">
                <div class="muven-card mb-3">
                    <div class="muven-card-title">
                        <p>Imagens</p>
                    </div>

                    <div class="product-image-container">
                        <div v-if="!product.hasImages()">
                            <p>-</p>
                        </div>

                        <div class="text-center row justify-content-center" v-if="product.hasImages()">
                            <div class="col" v-for="(img, index) in product.getImages()" :key="index">
                                <img :class="{
                                        'product-image-main': img.isMain,
                                        'product-image-inactive': !img.isActive,
                                    }"
                                    :src="img.url" 
                                    alt="Imagem"
                                    @click="viewProductImage($event)">
                                <p class="product-image-dimensions">
                                    <span>{{img.getSizeInformation()}}</span>
                                </p>
                                <p class="product-image-description"
                                    :class="{
                                        'image-main': img.isMain && img.isActive,
                                        'image-inactive': !img.isActive,
                                    }"> 
                                    <span v-if="img.isMain && img.isActive">Principal</span>                                        
                                    <span v-if="!img.isActive">Inativa</span>                                        
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { ProductModel } from '@/product/models/ProductModel'
import { dateTimeFilter } from '@/utils/filters/DateTimeFilter'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { EntityEnum, OrderStatusEnum } from '@c2b/muven-commons'
import GetAuditUrl from '../../utils/mixins/GetAuditUrl'
import { StoreModel } from '@/store/models/StoreModel'
import { ProductStoreModel } from '../models/ProductStoreModel'

export default {
    name: 'ProductSimpleCmp',    
    props: {
        product: {
            required: true,
            type: ProductModel,
            default: new ProductModel(),
        },
    },
    data() {
       return {
            EntityEnum,
            productImageUrl: '',
            productImageBeingViewed: false,
            productStoreList: [],
            chosenStore: new StoreModel(),
            chosenProductStore: new ProductStoreModel(),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Produtos',
                    path: '/produtos',
                },
                {
                    id: 1,
                    description: `Detalhes de #${this.$route.params.id}`,
                    path: '',
                },
            ],
       } 
    },
    filters: {
        dateTimeFilter,        
        infoOrPlaceholder,
    },
    mixins: [
        GetAuditUrl,
    ],
    methods: {
        viewProductImage(ev) {
            this.productImageUrl = ev.target.currentSrc
            this.productImageBeingViewed = true
        },
        closeProductImageVisualization() {
            this.productImageBeingViewed = false
        },
        gotoModification(product) {
            this.$router.push(`/produtos/${product.id}/edicao`)
        },
        chooseStoreFromList(store) {
            this.chosenStore = store
            this.chosenProductStore = this.product.getProductStoreInfo(store)
        },
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
        chosenProductStoreHasChannels() {
            if (!this.chosenProductStore.channels) {
                return false
            }

            return !!this.chosenProductStore.channels.length
        },
        urlToReservedStockOrder() {
            if (!this.subscriber.isBackendBimer()) {
                return `/pedidos?custom=true&productIdList=${this.product.id}&statusList=${OrderStatusEnum.Pending}`
            }

            return `/pedidos?custom=true&productIdList=${this.product.firstChildId}&statusList=${OrderStatusEnum.Pending}`
        },
        urlToOrder() {
            if (!this.subscriber.isBackendBimer()) {
                return `/pedidos?custom=true&productIdList=${this.product.id}`
            }

            return `/pedidos?custom=true&productIdList=${this.product.firstChildId}`
        },
    },
    watch: {
        product: {
            deep: true,
            handler(p) {
                this.productStoreList = StoreModel.getStoreListWithIdAndName(p.getStoreList())
                this.chooseStoreFromList(this.productStoreList[0])
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.muven-product-big-image-visualization {
    .muven-product-big-image-backdrop {
        position: fixed;
        background-color: var(--surface-tooltip);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 998;
        opacity: .6;
    }

    .muven-product-big-image-container {
        position: fixed;
        top: 10vh;
        left: 0;
        z-index: 999;

        img {
            border-radius: 0;
            width: 100%;
        }

        .muven-product-big-image-close-icon {
            cursor: pointer;
            position: fixed;
            color: var(--text-on-tooltip);
            font-size: 2em;
            top: calc(10vh - 55px);
            right: 15px;
        }

        @media(min-width: 768px) {
            left: 50%;
            transform: translateX(-50%);

            img {
                border-radius: 2px;
                max-width: 80vh;
            }

            .muven-product-big-image-close-icon {
                top: -55px;
                right: auto;
            }
        }
    }
}

.muven-card {
    overflow: hidden;

    &.store-info-card {
        overflow: unset;
    }

    .main-product-info-container {
        height: 378px;
        overflow: auto;
    }

    .product-image-container {
        img {
            display: block;
            width: 150px;
            height: 150px;
            margin: 0 auto 10px auto;
        }

        .product-image-dimensions {
            margin: -10px 0 10px 0;
            color: var(--text-muted);
        }

        .product-image-description {
            &.image-main,
            &.image-inactive {
                border: 1px solid var(--border);
                padding: 0;
                max-width: 70px;
                border-radius: 2px;
                margin: 0 auto;
                font-size: .85em;
                letter-spacing: 1px;
                margin-bottom: 15px;
            }

            &.image-main {
                border-color: var(--brand-soft);
                color: var(--brand);
                background-color: var(--tint-brand-hover);
            }

            &.image-inactive {
                background-color: var(--surface-3);
                color: var(--text-muted);
            }
        }

        @media(min-width: 992px) {
            img {
                cursor: pointer;
                display: inline-block;
                width: 200px;
                height: 175px;
                margin-top: 15px;
                margin-right: 15px;           
                margin-bottom: 15px;

                &:last-of-type {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>

